import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { RadioOption } from "@/components/shared/radio-list/radio-list.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DateRangeFilterModalComponent } from "@/components/shared/modals/date-range-filter-modal/date-range-filter-modal.component";
import { from, tap } from "rxjs";
import { getDateRangeForTimeFrame } from "@/_utility/date.utils";

@Component({
    selector: "app-insights-filter-sidebar",
    templateUrl: "./insights-filter-sidebar.component.html",
    styleUrls: ["./insights-filter-sidebar.component.scss"],
})
export class InsightsFilterSidebarComponent implements OnInit {
    @Input() filterForm: UntypedFormGroup;
    @Output() closeButtonClicked: EventEmitter<void> = new EventEmitter<void>();

    @Input() userList: RadioOption[];
    @Input() timeFrameList: RadioOption[];
    @Input() formType: RadioOption[];
    @Input() aircraftList: RadioOption[];
    @Input() formList: RadioOption[];

    constructor(private modalService: NgbModal) {}

    ngOnInit() {}

    setDateRangeValue(control: UntypedFormControl, value: any) {
        control.setValue(value);
        if (value === "") {
            return this.filterForm.get("flightDate").setValue("");
        }
        if (value === "custom") {
            const filterModal = this.modalService.open(
                DateRangeFilterModalComponent,
            );
            const component =
                filterModal.componentInstance as DateRangeFilterModalComponent;
            component.control = this.filterForm.get(
                "flightDate",
            ) as UntypedFormControl;

            from(filterModal.result)
                .pipe(
                    tap(() => {
                        if (!this.filterForm.get("flightDate").value.length) {
                            this.setDateRangeValue(control, "");
                            control.setValue("");
                        }
                    }),
                )
                .subscribe();
        } else {
            const range = getDateRangeForTimeFrame(value);
            if (range) {
                return this.filterForm.get("flightDate").setValue(range);
            }
        }
    }

    close() {
        this.closeButtonClicked.emit();
    }
}
